import React, { useState } from "react";
import { Img } from "./Img";
import { usePetFiles } from "../../../hooks/uploads/usePetFiles";
import { Button } from "@mui/material";
import FileSelectorDialog from "../../common/forms/FileSelectorDialog";
import { useUploadFile } from "../../../hooks/uploads/useUploadFile";
import { useSnackbar } from "../../../context/SnackbarContext";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { useDeleteFile } from "../../../hooks/uploads/useDeleteFile";
import VerticalHamburgerMenu from "../../common/controls/VerticalHamburgerMenu";

export function ProfilePicture({ petId }) {
    const { t } = useTranslation('common');
    const { showSnackbar } = useSnackbar();

    const [fileSelectorDialogOpen, setFileSelectorDialogOpen] = React.useState(false);
    const onFileSelectorClose = () => {
        setFileSelectorDialogOpen(false);
    };

    const [trigger, setTrigger] = React.useState(false);
    // Toggle function
    const toggleTrigger = () => {
        setTrigger(prev => !prev);
    };

    const { petFiles, loading } = usePetFiles(petId, {
        page: 0,
        limit: 0,
        tags: "profilePicture",
        trigger
    });

    const [tags, setTags] = useState(["profilePicture"]);

    const onFileUploadSuccess = () => {
        showSnackbar(t('files.messages.upload_success'), "success");
        setFileSelectorDialogOpen(false);
        toggleTrigger();
    };

    const { upload, progress } = useUploadFile(onFileUploadSuccess);
    
    const handleUploadPicture = async (file) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("tags", JSON.stringify(tags));
        try {
            await upload(petId, formData);
        } catch (error) {
            if (error.status === 415)
            {
                showSnackbar(t("files.messages.unsupported_file_type"), "error");
            }
            else if (error.status === 414)
            {
                showSnackbar(t("files.messages.file_quota_exceeded"), "error");
            }
            else if (error.status === 413)
            {
                showSnackbar(t("files.messages.file_too_large"), "error");
            }
            else {
                showSnackbar(t("files.messages.upload_failed"), "error");
            }
        }
    };

    const onFileDeleteSuccess = () => {
        showSnackbar(t('files.messages.delete_success'), "success");
        toggleTrigger();
    };

    const { remove } = useDeleteFile(onFileDeleteSuccess);

    const handleDeleteFile = async (fileId) => {
        try {
            await remove(fileId);
        } catch (err) {
            showSnackbar(t('files.messages.delete_fail'), "error");
        }
    };

    return (
        <>
        <Stack spacing={1}>
        { petFiles && petFiles.attachments && petFiles.attachments.length > 0 ? 
            <>
            <Box
                sx={{
                position: 'relative', // parent must be relative for absolute children
                borderRadius: 2,
                overflow: 'hidden', // Ensures the image inside is clipped
                display: 'inline-block', // keeps Box sized to its content
                boxShadow: 8
                }}
            >
                <Img 
                fileId={petFiles.attachments[0].id} 
                ratio="16:9" 
                alt="Pet photo" 
                />

                {/* Place the menu inside the Box */}
                <Box
                sx={{
                    position: 'absolute',
                    bottom: 8,   // adjust spacing from bottom
                    right: 8,    // adjust spacing from right
                }}
                >
                <VerticalHamburgerMenu 
                    options={[
                    {
                        id: 3,
                        name: 'Delete',
                        callback: () => handleDeleteFile(petFiles.attachments[0].id),
                        confirmMessage: t('files.messages.delete_confirm'),
                    }
                    ]}
                />
                </Box>
            </Box>
            </>

        : null }
        <Button
            onClick={() => setFileSelectorDialogOpen(true)}
            variant="outlined"
            component="label"
            fullWidth
        >
            Upload Picture
        </Button>
        </Stack>
        <FileSelectorDialog 
            fileType='image'
            open={fileSelectorDialogOpen}
            onClose={onFileSelectorClose}
            onSubmit={handleUploadPicture}
            progress={progress}
            showRecordVoice={false}
        />
        </>
    );
}